import { useState, useEffect } from 'react';
import { toaster } from 'evergreen-ui';
import {
  fetchReperibilitaByMonth,
  saveReperibilita,
  updateReperibilita,
  deleteReperibilita,
} from '../../services/reperibilitaService';

export const EMPTY_REP = {
  id: null,
  date: '',
  operator_id: null,
  operator_name: '',
  start_time: '',
  end_time: '',
  period: 'giorno',
  notes: '',
};

const useReperibilita = ({ selectedMonth }) => {
  const [reperibilitaData, setReperibilitaData] = useState([]);
  const [repInputs, setRepInputs] = useState(EMPTY_REP);

  const loadReperibilita = async () => {
    try {
      const data = await fetchReperibilitaByMonth(selectedMonth);
      setReperibilitaData(data || []);
    } catch (e) {
      toaster.danger('Errore caricamento reperibilità: ' + e.message);
    }
  };

  useEffect(() => { loadReperibilita(); }, [selectedMonth]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSaveReperibilita = async () => {
    try {
      if (repInputs.id) {
        await updateReperibilita(repInputs);
        toaster.success('Reperibilità aggiornata');
      } else {
        await saveReperibilita(repInputs);
        toaster.success('Reperibilità salvata');
      }
      setRepInputs(EMPTY_REP);
      await loadReperibilita();
      return true;
    } catch (e) {
      toaster.danger('Errore: ' + e.message);
      return false;
    }
  };

  const handleDeleteReperibilita = async (id) => {
    try {
      await deleteReperibilita(id);
      toaster.success('Reperibilità eliminata');
      await loadReperibilita();
    } catch (e) {
      toaster.danger('Errore eliminazione: ' + e.message);
    }
  };

  return {
    reperibilitaData,
    repInputs,
    setRepInputs,
    loadReperibilita,
    handleSaveReperibilita,
    handleDeleteReperibilita,
  };
};

export default useReperibilita;
